<script setup>

import {ref, defineComponent, onMounted, onBeforeUnmount} from "vue";
  import { Splide, SplideSlide } from '@splidejs/vue-splide';
  import '@splidejs/vue-splide/css';
  import FontAwesomeIcon from '../../ts/fontawesome-icons.ts';

  const props = defineProps({
    product: {
      type: Object,
    },
  })

  const mainOptions = {
    rewind: true,
    type      : 'loop',
    perPage   : 1,
    perMove   : 1,
    gap       : '1rem',
    pagination: false,
    arrows: true,
    drag: false,
    dragAngleThreshold: 0,
    classes: {
      prev  : 'splide__arrow--prev bg-white',
      next  : 'splide__arrow--next bg-white',
    }
  };

  const thumbsOptions = {
    type        : 'slide',
    rewind      : true,
    gap         : '',
    pagination  : false,
    fixedWidth  : '100%',
    fixedHeight : '100px',
    focus       : 'center',
    isNavigation: true,
    updateOnMove: true,
    direction: 'ttb',
    height   : '100%',
    classes: {
      prev  : 'splide__arrow--prev bg-white',
      next  : 'splide__arrow--next bg-white',
    }
  };

  //ELEMENTS
  let thumbssplideref = ref(null);
  let mainsplideref = ref(null);
  let productcarouselref = ref(null);
  let productcarouselchildelementref = ref(null)

  //CAROUSEL
  let carouselProduct = ref({
    productName: props.product.productName,
    images: props.product.images,
    videos: props.product.videos,
    isUsingCylindoAssets: props.product.isUsingCylindoAssets,
    cylindoImages: props.product.cylindoImages,
    onTopSplatterText: props.product.onTopSplatterText,
    onTopSplatterType: props.product.onTopSplatterType
  })

  if(!window["co3VueProductCarousel"]) {
    window["co3VueProductCarousel"] = [ carouselProduct ];
  } else {
    window["co3VueProductCarousel"].push(carouselProduct);
  }

  let carouselIsExpanded = false;
  let carouselHasPages = false;
  let isMobileSize = false;
  let hasVerticalNavigation = true;
  let renderedThumbsOnce = false;

  const handleCarouselPadding = () => {
    if(mobileMatch.matches) {
      productcarouselref.value.style.padding = '1rem 1rem';
    } else {
      productcarouselref.value.style.padding = '4% 8%';
    }
  }

  const SetMobileRestrictions = () => {
    isMobileSize = true;
    CloseCarousel();
    Array.from(productcarouselref.value.querySelectorAll('.js-pointer-events-toggle')).forEach((element, index) => {
      element.classList.remove('tw-pointer-events-none');
    });
    RenderThumbs();
  }

  const RemoveMobileRestrictions = () => {
    isMobileSize = false;
    Array.from(productcarouselref.value.querySelectorAll('.js-pointer-events-toggle')).forEach((element, index) => {
      element.classList.add('tw-pointer-events-none');
    });
    RenderThumbs();
  }

  const ExpandCarousel = (e) => {
    if(e) {
      e.stopPropagation();
    }
    if(!isMobileSize) {
      carouselIsExpanded = true;
      let maybeVideo = e.target.querySelector(".video-to-pause-on-move");
      let closeButton = productcarouselref.value.querySelector(".js-modal-closer");
      if(closeButton) {
        closeButton.classList.remove("tw-hidden");
      }
      if(maybeVideo) {
        PlayVideo(maybeVideo);
      }
      Array.from(productcarouselref.value.querySelectorAll('.js-pointer-events-toggle')).forEach((element, index) => {
        element.classList.remove('tw-pointer-events-none');
      });
      productcarouselref.value.classList.add("is-expanded");
      productcarouselref.value.style.zIndex = '40';
      productcarouselref.value.style.position = 'fixed';
      handleCarouselPadding();
      productcarouselchildelementref.value.style.border = "1px solid black";
      productcarouselchildelementref.value.style.padding = "3em 1.5em";
      //mainsplideref.value.go(mainsplideref.value.index);

      let splash = productcarouselref.value.querySelector(".product-card-splash");
      if(splash) {
        splash.style.display = 'none';
      }

      //Hide weply and emaerke
      const emaerketWidget = document.getElementById('emaerket-widget-container');
      const weplyWidget = document.querySelector('iframe[title="Weply chat"]');
      const cookiebotWidget = document.getElementById("CookiebotWidget");
      if(cookiebotWidget != null) {
        cookiebotWidget.classList.add('d-none');
      }
      if(emaerketWidget != null) {
        emaerketWidget.classList.add('d-none');
      }
      if(weplyWidget != null) {
        weplyWidget.classList.add('d-none');
        weplyWidget.style.display = "none";
      }
    }

    mainsplideref.value.splide.event.emit('resize');
    thumbssplideref.value.splide.event.emit('resize');
  }

  const CloseCarousel = (e) => {
    if(e) {
      e.stopPropagation();
    }
    carouselIsExpanded = false;
    StopVideos();
    let closeButton = productcarouselref.value.querySelector(".js-modal-closer");
    if(closeButton) {
      closeButton.classList.add("tw-hidden");
    }
    Array.from(productcarouselref.value.querySelectorAll('.js-pointer-events-toggle')).forEach((element, index) => {
      element.classList.add('tw-pointer-events-none');
    });
    productcarouselref.value.classList.remove("is-expanded");
    productcarouselref.value.style.zIndex = 'inherit';
    productcarouselref.value.style.position = 'inherit';
    productcarouselref.value.style.padding = '0';
    productcarouselchildelementref.value.style.border = "0";
    productcarouselchildelementref.value.style.padding = "0";

    let splash = productcarouselref.value.querySelector(".product-card-splash");
    if(splash) {
      splash.style.display = '';
    }

    //Show weply and emaerke
    const emaerketWidget = document.getElementById('emaerket-widget-container');
    const weplyWidget = document.querySelector('iframe[title="Weply chat"]');
    const cookiebotWidget = document.getElementById("CookiebotWidget");
    if(cookiebotWidget != null) {
      cookiebotWidget.classList.remove('d-none');
    }
    if(emaerketWidget != null) {
      emaerketWidget.classList.remove('d-none');
    }
    if(weplyWidget != null) {
      weplyWidget.classList.remove('d-none');
      weplyWidget.style.display = "unset";
    }

    mainsplideref.value.splide.event.emit('resize');
    thumbssplideref.value.splide.event.emit('resize');
  }

  const RenderVerticalThumbs = () => {
    hasVerticalNavigation = true;
    thumbssplideref.value.splide.options = {
      direction: 'ttb',
      fixedWidth  : '100%',
      fixedHeight : '20%',
    };
    mainsplideref.value.splide.options = {
      arrows: true,
    };
    thumbssplideref.value.root.classList.remove("tw-w-full");
    thumbssplideref.value.root.classList.remove("tw-h-1/6");

    thumbssplideref.value.root.classList.add("tw-h-full");
    thumbssplideref.value.root.classList.add("tw-w-1/6");
    thumbssplideref.value.root.classList.add("tw-absolute");

    mainsplideref.value.root.classList.add('tw-w-5/6');
    mainsplideref.value.root.classList.add('tw-h-full');
    mainsplideref.value.root.classList.remove('tw-w-full');
    mainsplideref.value.root.classList.remove('tw-h-5/6');

    let container = productcarouselchildelementref.value.querySelector('.js-splide-direction-container');
    container.classList.remove("tw-flex");
    container.classList.remove("tw-flex-col-reverse");

    mainsplideref.value.splide.event.emit('resize');
    thumbssplideref.value.splide.event.emit('resize');
    renderedThumbsOnce = true;
  }

  const RenderHorisontalThumbs = () => {
    hasVerticalNavigation = false;
    thumbssplideref.value.splide.options = {
      direction: 'ltr',
      fixedWidth: '25%',
      fixedHeight: '100%',
    };
    mainsplideref.value.splide.options = {
      arrows: false,
    };

    thumbssplideref.value.root.classList.add("tw-w-full");
    thumbssplideref.value.root.classList.add("tw-h-1/6");

    thumbssplideref.value.root.classList.remove("tw-h-full");
    thumbssplideref.value.root.classList.remove("tw-w-1/6");
    thumbssplideref.value.root.classList.remove("tw-absolute");

    mainsplideref.value.root.classList.remove('tw-w-5/6')
    mainsplideref.value.root.classList.remove('tw-h-full');
    mainsplideref.value.root.classList.add('tw-w-full');
    mainsplideref.value.root.classList.add('tw-h-5/6');

    let container = productcarouselchildelementref.value.querySelector('.js-splide-direction-container');
    container.classList.add("tw-flex");
    container.classList.add("tw-flex-col-reverse");

    mainsplideref.value.splide.event.emit('resize');
    thumbssplideref.value.splide.event.emit('resize');
    renderedThumbsOnce = true;
  }

  const RenderThumbs = () => {
    if(carouselHasPages) {
      if (productcarouselref.value.clientWidth > productcarouselref.value.clientHeight) {
        if (hasVerticalNavigation === false || renderedThumbsOnce === false) {
          RenderVerticalThumbs();
        }
      } else if (hasVerticalNavigation === true || renderedThumbsOnce === false) {
        RenderHorisontalThumbs();
      }
    }
  }

  const StopVideos = () => {
    Array.from(mainsplideref.value.root.querySelectorAll("iframe.video-to-pause-on-move")).forEach((element, index) => {
      element.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
    });
  }

  const PlayVideo = (element) => {
    element.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  }

  const StopPropagation = (e) => {
    e.stopPropagation();
  }
  const keydownHandler = (e) => {
    if (event.key === "Escape") {
      CloseCarousel(e);
    }
  }

  const checkSplideLength = () => {
    if ( mainsplideref.value.splide.length <= mainsplideref.value.splide.options.perPage ) {
      //HIDE THUMBS IF ONLY 1 PAGE
      thumbssplideref.value.root.classList.remove("tw-block");
      thumbssplideref.value.root.classList.add("tw-hidden");

      //SET MAIN SPLIDE TO OCCUPY FULL AREA
      mainsplideref.value.root.classList.remove("tw-w-5/6");
      mainsplideref.value.root.classList.remove("tw-h-5/6");
      mainsplideref.value.root.classList.add("tw-h-full");
      mainsplideref.value.root.classList.add("tw-w-full");

      mainsplideref.value.splide.options = {
        arrows: false,
      };
      carouselHasPages = false;
    } else {
      //SHOW THUMBS
      thumbssplideref.value.root.classList.add("tw-block");
      thumbssplideref.value.root.classList.remove("tw-hidden");

      RenderThumbs();

      mainsplideref.value.splide.options = {
        arrows: true,
      };
      carouselHasPages = true;
    }
  }

  // Create a condition that targets viewports at least 768px wide
  const mobileMatch = window.matchMedia('(max-width: 992px)');

  const handleMobileDesktopChange = (e) => {
    // Check if the media query is true
    if(carouselIsExpanded) {
      handleCarouselPadding();
    }
    if (e.matches) {
      SetMobileRestrictions();
    } else {
      RemoveMobileRestrictions();
    }
  }

  // Register event listener
  mobileMatch.addEventListener('change', handleMobileDesktopChange);
  window.addEventListener("resize", (e) => {
    RenderThumbs();
  });

  onBeforeUnmount(() => {
    window.removeEventListener('keydown', keydownHandler);
  });

  onMounted( () => {
    window.addEventListener('keydown', keydownHandler);

    productcarouselref.value.style.backgroundColor = 'rgba(0,0,0,0.5)';

    Array.from(productcarouselref.value.querySelectorAll('.splide__track')).forEach((element, index) => {
      element.classList.add('tw-h-full');
    });

    if(mainsplideref.value) {
      if ( thumbssplideref.value.splide ) {
        mainsplideref.value.sync(thumbssplideref.value.splide);
      }

      mainsplideref.value.splide.on('move', () => {
        StopVideos();
      });

      mainsplideref.value.splide.on('refresh', () => {
        checkSplideLength();
        handleMobileDesktopChange(mobileMatch);
        mainsplideref.value.splide.event.emit('resize');
        thumbssplideref.value.splide.event.emit('resize');
      });

      // Initial check
      checkSplideLength();
      handleMobileDesktopChange(mobileMatch);
    }

  });

</script>

<template>
  <div class="product-splide-carousel-carousel mb-3">

    <div class="tw-flex tw-relative tw-w-full tw-h-full tw-top-0 tw-bottom-0 tw-left-0 tw-right-0" ref="productcarouselref" v-on:click="CloseCarousel">
      <div class="tw-w-full tw-h-full tw-relative bg-white" v-on:click="StopPropagation" ref="productcarouselchildelementref">

        <div v-on:click="CloseCarousel" style="z-index:50;margin:0.5em 1em;" class="tw-absolute tw-right-0 tw-top-0 tw-hidden tw-p-1.5 tw-cursor-pointer js-modal-closer">
            <span class="tw-mr-2">Luk</span>
            <font-awesome-icon icon="close" />
        </div>

        <div class="js-splide-direction-container tw-w-full tw-h-full tw-relative">

          <div v-if="carouselProduct.onTopSplatterText" class="splash splash--on-top p-1 product-card-splash" :class="carouselProduct.onTopSplatterType">
            <p class="m-0" style="">{{ carouselProduct.onTopSplatterText }}</p>
          </div>

          <Splide class="tw-block tw-absolute tw-top-0 tw-bottom-0 mobile-thumb-height" :options="thumbsOptions" ref="thumbssplideref">

            <SplideSlide v-if="carouselProduct.isUsingCylindoAssets === true" class="js-cylindo-main-thumbnail-container-target-container">
              <div class="tw-w-full tw-h-full tw-flex tw-items-center">
                <img class="js-cylindo-main-container-thumbnail-target tw-w-full tw-h-full tw-hidden tw-object-contain" width="400" height="400" src="" :alt="carouselProduct.productName" />
              </div>
            </SplideSlide>
            <SplideSlide v-if="carouselProduct.isUsingCylindoAssets === true" v-for="image in carouselProduct.cylindoImages">
              <div class="tw-w-full tw-h-full tw-flex tw-items-center">
                <img class="tw-w-full tw-h-full tw-object-contain"  width="400" height="400" :src="image" :alt="carouselProduct.productName" >
              </div>
            </SplideSlide>
            <SplideSlide v-if="carouselProduct.isUsingCylindoAssets === false" v-for="image in carouselProduct.images">
              <div class="tw-w-full tw-h-full tw-flex tw-items-center">
                <img class="tw-w-full tw-h-full tw-object-contain" width="400" height="400"  :src="image" :alt="carouselProduct.productName" >
              </div>
            </SplideSlide>
            <SplideSlide v-for="videoId in carouselProduct.videos">
              <div class="tw-w-full tw-h-full tw-flex tw-items-center">
                <img class="tw-w-full tw-h-full tw-object-contain" width="400" height="400" :src="`https://i3.ytimg.com/vi/${videoId}/hqdefault.jpg`" :alt="carouselProduct.productName" />
              </div>
            </SplideSlide>

          </Splide>

          <Splide class="tw-ml-auto" :options="mainOptions" ref="mainsplideref">

            <SplideSlide v-if="carouselProduct.isUsingCylindoAssets === true" class="js-cylindo-main-container-target-container" v-on:click="ExpandCarousel">
              <div class="tw-w-full tw-h-full tw-flex tw-items-center tw-pointer-events-none js-pointer-events-toggle">
                <div class="js-cylindo-main-container-target tw-w-full tw-h-full"></div>
              </div>
            </SplideSlide>
            <SplideSlide v-if="carouselProduct.isUsingCylindoAssets === true" v-for="image in carouselProduct.cylindoImages" v-on:click="ExpandCarousel" data-type="cylindo">
              <div class="tw-w-full tw-h-full tw-flex tw-items-center tw-pointer-events-none js-pointer-events-toggle">
                <img class="tw-w-full tw-h-full tw-object-contain" width="800" height="600"  :src="image" :alt="carouselProduct.productName" >
              </div>
            </SplideSlide>
            <SplideSlide v-if="carouselProduct.isUsingCylindoAssets === false" v-for="image in carouselProduct.images" v-on:click="ExpandCarousel">
              <div class="tw-w-full tw-h-full tw-flex tw-items-center tw-pointer-events-none js-pointer-events-toggle">
                <img class="tw-w-full tw-h-full tw-object-contain" width="800" height="600" :src="image" :alt="carouselProduct.productName" >
              </div>
            </SplideSlide>
            <SplideSlide v-for="videoId in carouselProduct.videos" v-on:click="ExpandCarousel">
              <div class="tw-w-full tw-h-full tw-flex tw-items-center tw-pointer-events-none js-pointer-events-toggle">
                <div style="padding-bottom: 56.25%;" class="tw-w-full tw-h-0 tw-flex tw-items-center tw-pointer-events-none tw-relative js-pointer-events-toggle">
                  <iframe style="position: absolute; top: 0; left: 0;" class="video-to-pause-on-move" width="100%" height="100%" :src="`https://www.youtube.com/embed/${videoId}?rel=0&controls=1&modestbranding=1&enablejsapi=1`" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>
              </div>
            </SplideSlide>

          </Splide>

        </div>
      </div>
    </div>

  </div>
</template>

